import styled from '@emotion/styled';
import { ButtonLinkWithIcon } from '@blueprint/ui';
import { css } from '@emotion/react';

export type MobileQuickMenuWrapperProps = {
    carouselShown?: boolean;
};

export const MobileQuickMenuWrapper = styled(
    'div'
)<MobileQuickMenuWrapperProps>(
    ({
        carouselShown = false,
        theme: { spacing, colors, borderRadius }
    }) => css`
        display: flex;
        flex-direction: row;
        justify-content: center;
        pointer-events: none;
        position: absolute;
        bottom: ${carouselShown ? '138px' : '24px'};
        left: 50%;
        transform: translateX(-50%);
        border: 1px solid white;
        height: ${spacing['48px']};
        transition: bottom 300ms;
        box-shadow: 0px 4px 10px 0px ${colors['black-opacity30']};
        border-radius: ${borderRadius['300']};
        justify-content: left;
        border: none;
    `
);

const StyledButton = styled(ButtonLinkWithIcon)(
    ({ theme: { colors, spacing, fontSizes } }) => {
        return css`
            background-color: ${colors['graphic-background']};
            border: 0px solid transparent;
            height: ${spacing['48px']};
            font-size: ${fontSizes[1]};
            padding: ${fontSizes[0]};
            pointer-events: all;
            white-space: nowrap;
            min-width: 0 !important;
            width: auto;

            svg {
                flex-shrink: 0;
            }
        `;
    }
);

export const StyledLeftButtonWithIcon = styled(StyledButton)(
    ({ theme: { borderRadius } }) => css`
        border-radius: ${borderRadius['300']} ${borderRadius['100']}
            ${borderRadius['100']} ${borderRadius['300']};
        border-right: none;
    `
);

export const StyledRightButtonWithIcon = styled(StyledButton)(
    ({ theme: { borderRadius, colors } }) => css`
        border-left: 1px solid ${colors['neutral-3']};
        border-radius: ${borderRadius['100']} ${borderRadius['300']}
            ${borderRadius['300']} ${borderRadius['100']};
    `
);
